import { useEffect, useState } from "react";
import { Headset, LifeBuoy, Loader2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/common";
import { IconAction } from "@/components/IconAction";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export function SupportButton({ compact }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {compact ? <IconAction label="Fale com o suporte" icon={Headset} onClick={() => setOpen(true)} testId="open-support-btn" />
        : <Button variant="outline" size="sm" className="w-full" onClick={() => setOpen(true)} data-testid="open-support-btn"><LifeBuoy className="h-4 w-4 mr-1" />Fale com o suporte</Button>}
      <SupportDialog open={open} onOpenChange={setOpen} />
    </>
  );
}

function SupportDialog({ open, onOpenChange }) {
  const [cats, setCats] = useState([]);
  const [f, setF] = useState({ category: "", message: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open && !cats.length) api.get("/support/categories").then((r) => setCats(r.data)).catch(() => {}); }, [open, cats.length]);
  useEffect(() => { if (open) setF({ category: "", message: "" }); }, [open]);
  const send = async () => {
    if (!f.category) return toast.error("Escolha o assunto");
    if (f.message.trim().length < 10) return toast.error("Descreva o pedido com pelo menos 10 letras");
    setBusy(true);
    try {
      await api.post("/support/requests", f);
      toast.success("Pedido enviado! O suporte vai responder no seu e-mail.");
      onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="support-dialog">
        <DialogHeader>
          <DialogTitle>Fale com o suporte</DialogTitle>
          <DialogDescription>Conte o que precisa. A resposta chega no e-mail cadastrado da sua conta.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Field label="Assunto">
            <Select value={f.category} onValueChange={(v) => setF((x) => ({ ...x, category: v }))}>
              <SelectTrigger data-testid="support-category-select"><SelectValue placeholder="Escolha o assunto" /></SelectTrigger>
              <SelectContent>{cats.map((c) => <SelectItem key={c} value={c} data-testid={`support-category-${c}`}>{c}</SelectItem>)}</SelectContent>
            </Select>
          </Field>
          <Field label="Mensagem" hint={`${f.message.length}/2000`}>
            <Textarea rows={6} maxLength={2000} value={f.message} onChange={(e) => setF((x) => ({ ...x, message: e.target.value }))} placeholder="Ex.: não consigo imprimir o cupom no caixa 2" data-testid="support-message-input" />
          </Field>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={send} disabled={busy} data-testid="support-send-btn">{busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Send className="h-4 w-4 mr-2" />}Enviar pedido</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
